export default {
	namespaced: true,

	state: {
		applications: []
	},

	mutations: {
		/**
		 * [setLoanApplications description]
		 * @param {[type]} state        [description]
		 * @param {[type]} applications [description]
		 */
		setLoanApplications(state, applications) {
			state.applications= applications
		}
	},

	getters: {
		/**
		 * [applications description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		applications(state) {
			return state.applications
		}
	},

	actions: {
		/**
		 * [get_disbursed description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @return {[type]}                 [description]
		 */
		get_disbursed({commit, getters}) {
			return this._vm.$http.get('loan-applications/member/disbursed')
				.then(response => {
					return response.data
				})
		},
		/**
		 * [getActiveCalculation description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getActiveCalculation({commit, getters}, calculation_id) {
			// return this._vm.$http.get('loan-applications/member/active-calculation/account/'+account_id+'/loan/'+loan_id)
			return this._vm.$http.get('loan-applications/member/active-calculation/'+calculation_id)
				.then(response => {
					return response.data
				})
		},

		/**
		 * [calculate description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} options.form    [description]
		 * @param  {[type]} options.loan_id [description]
		 * @return {[type]}                 [description]
		 */
		calculate({commit, getters}, {form, loan_id}) {
				// return this._vm.$http.post('loan-applications/member/calculate/'+loan_id, form)
				return this._vm.$http.post('loan-applications/member/calculate/'+loan_id, form, {
					params: {calculate: true}
				})
					.then(response => response.data)
		},

		/**
		 * [save_calculation description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} (form,          loan_id)      [description]
		 * @return {[type]}                 [description]
		 */
		save_calculation({commit, getters}, {form, loan_id}) {
			return this._vm.$http.post('loan-applications/member/calculate/'+loan_id, form)
					.then(response => response.data)
		},

		/**
		 * [getApplication description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} loan_id         [description]
		 * @return {[type]}                 [description]
		 */
		getApplication({commit, getters}, loan_id) {
			// return this._vm.$http.get('loan-applications/information/'+loan_id)
			return this._vm.$http.get('loan-applications/member/information/'+loan_id)
				.then(response => {
					return response.data
				})
		},

		/**
		 * [getLoanApplications description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getLoanApplications({commit, getters}, payload) {
			if(getters['applications'].length) {
				return Promise.resolve(getters['applications'])
			}
			return this._vm.$http.get('loan-applications/available')
				.then(response => {
					commit('setLoanApplications', response.data)
					return response.data
				})
		}
	}
}